import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { TooltipHost, DirectionalHint } from "@fluentui/react";
import styles from "./Layout.module.css";
import { authMS, authLOCAL, authGOOGLE } from "../../authConfig";
import { useMsal } from "./../../MsalContext";
import { LoginButton } from "../../components/LoginButton";
import { AccountInfo, AuthenticationResult } from "@azure/msal-browser";
import kognifyLogo from "../../assets/kognify_logo.svg";
import loginLoc from "../../assets/Font_Awesome_5_Solid_Envelope.svg";
import LoginMS from "../../assets/Microsoft.svg";
import loginGoo from "../../assets/google.svg";
import linkedinLogo from "../../assets/linkedin.svg";
import AutonomousAP from "../../components/marketing/AutonomousAP";
import AutonomousCallCenter from "../../components/marketing/AutonomousCallCenter";
import { ScrollDownAnimatedArrows } from "../../components/ScrollDownAnimatedArrows/ScrollDownAnimatedArrows";
import MainAccordion from "../../components/marketing/MainAccordion";
import { getStoryPreference, getRedeemSpaceName, getTokenMail, getAnonToken, getUrlUid, getRedeemToken, generateRandomString, checkPathForInfoPages } from "./LayoutTooling";
import NavLogBut from "../../components/marketing/NavLogBut";
import {
    localStorageIsFrameKey,
    localStorageAuthUriKey,
    localStorageAuthTokKey,
    localStorageFactoryTokKey
}  from "./../../lsts"
import { landStoryIds, storyNavRes } from "../../interfaces";
import { IoMail } from "react-icons/io5";


const Layout = () => {

    const { msalInstance, updateAuthority } = useMsal();
    const [msalReady, setMsalReady] = useState<boolean>(false);
    const [logPageReady, setLogPageReady] = useState<boolean>(false);
    const [isIFrame, setIsIFrame] = useState<boolean>(false);
    const [activeSlide, setActiveSlide] = useState<number>(0);
    const [activeStory, setActiveStory] = useState<storyNavRes>(getStoryPreference());

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY < 70) {
                setActiveSlide(0);
            } else {
                setActiveSlide(1);
            }
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, []);

    const navToLogin = () => {
        if (getAnonToken() == "1") {
            fetch(import.meta.env.VITE_EXT_SERV_ANIP)
                .then(response => response.json())
                .then(data => {
                    let ipStr: string;
                    let urluid = getUrlUid();
                    let rndStr = getUrlUid() == "" ? generateRandomString(10) : urluid;
                    if (data && data.ip && data.ip != "") {
                        ipStr = data.ip;
                    } else {
                        ipStr = rndStr;
                    }
                    fetch("/qAddQuest", {
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify({
                            qUsr: ipStr,
                            rndStr: rndStr,
                            hsh: window.location.hash
                        })
                    })
                        .then(response => response.json())
                        .then(rspns => {
                            import.meta.env.DEV === true && console.log("‹add_q›", ipStr);
                            localStorage.setItem(localStorageAuthUriKey, authLOCAL.authority);
                            localStorage.setItem(localStorageAuthTokKey, JSON.stringify(rspns));

                            setMsalReady(true);
                        });
                })
                .catch(error => {
                    let ipStr = generateRandomString(10);
                    let rndStr = ipStr;
                    fetch("/qAddQuest", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            qUsr: ipStr,
                            rndStr: rndStr
                        })
                    })
                        .then(response => response.json())
                        .then(rspns => {
                            import.meta.env.DEV === true && console.log("‹add_q_er›", ipStr);
                            localStorage.setItem(localStorageAuthUriKey, authLOCAL.authority);
                            localStorage.setItem(localStorageAuthTokKey, JSON.stringify(rspns));

                            setMsalReady(true);
                        });
                });
        } else {
            setLogPageReady(true);
        }
    };

    const onAction = (resp: any) => {
        // callback from auth buttons
        import.meta.env.DEV === true && console.log("‹on_act›", resp);

        let mailChk = getTokenMail(resp);
        if (mailChk !== undefined && mailChk !== null && mailChk !== "") {
            import.meta.env.DEV === true && console.log("‹on_act_tol_mal›", mailChk);
            localStorage.setItem(localStorageAuthTokKey, JSON.stringify(resp));
            setMsalReady(true);
        } else {
            if (msalInstance !== null) {
                const acc: AccountInfo | null = msalInstance.getActiveAccount();

                if (acc !== null) {
                    msalInstance?.setActiveAccount(acc);
                    import.meta.env.DEV === true && console.log("‹on_act_act_acc›", acc);
                    setMsalReady(true);
                } else {
                    navToLogin();
                    //setLogPageReady(true);
                }
            } else {
                import.meta.env.DEV === true && console.log("‹on_act_emp›");
                navToLogin();
                //setLogPageReady(true);
            }
        }
    };
    const checkIFrame = (params: any) => {
        let isfrm = params.get("isfrm");
        if (isfrm !== null) {
            setIsIFrame(true);
            localStorage.setItem(localStorageIsFrameKey, "True");
        } else {
            setIsIFrame(false);
            localStorage.removeItem(localStorageIsFrameKey);
        }
    };

    useEffect(() => {
        let params = new URLSearchParams(window.location.search);
        const utok = localStorage.getItem(localStorageAuthTokKey);
        //getFragmentParams();
        if (utok) {
            const utokcache: AuthenticationResult = JSON.parse(utok);
            const mailChk = getTokenMail(utokcache);
            if (mailChk !== undefined && mailChk !== null && mailChk !== "") {
                setMsalReady(true);
                return;
            }
        }

        if (msalInstance === null) {
            import.meta.env.DEV === true && console.log("‹msal_null›");
            return;
        }

        checkIFrame(params);
        const accs: AccountInfo[] | null = msalInstance.getAllAccounts();
        if (accs.length > 0) {
            import.meta.env.DEV === true && console.log("‹accs_length›", accs?.length, accs);
            const exp = accs[0]?.idTokenClaims?.exp;

            const mailChk = getTokenMail(accs[0]);
            if (mailChk !== undefined && mailChk !== null && mailChk !== "") {
                if (accs[0].homeAccountId) {
                    let homeAccId = accs[0].homeAccountId;
                    if (homeAccId.indexOf("google_signup_signin") > -1) {
                        import.meta.env.DEV === true && console.log("‹tok_from_cach_goo›", homeAccId, accs?.length, accs);

                        localStorage.setItem(localStorageAuthUriKey, authGOOGLE.authority);
                        localStorage.setItem(localStorageAuthTokKey, JSON.stringify(accs[0]));

                        setMsalReady(true);

                        return;
                    } else if (homeAccId.indexOf("idp_aad_multi_single") > -1) {
                        // MS
                        import.meta.env.DEV === true && console.log("‹tok_from_cach_ms›", homeAccId, accs?.length, accs);

                        localStorage.setItem(localStorageAuthUriKey, authMS.authority);
                        localStorage.setItem(localStorageAuthTokKey, JSON.stringify(accs[0]));

                        setMsalReady(true);

                        return;
                    } else if (homeAccId.indexOf("b2c_1_signupsignin") > -1) {
                        // LOCAL
                        import.meta.env.DEV === true && console.log("‹tok_from_cach_loc›", homeAccId, accs?.length, accs);

                        localStorage.setItem(localStorageAuthUriKey, authLOCAL.authority);
                        localStorage.setItem(localStorageAuthTokKey, JSON.stringify(accs[0]));

                        setMsalReady(true);

                        return;
                    }
                }
            }

            import.meta.env.DEV === true && console.log("no_account_01");

            let passRes = params.get("passreset");
            if (passRes !== null) {
                localStorage.removeItem(localStorageFactoryTokKey);
                sessionStorage.removeItem(localStorageFactoryTokKey);
                updateAuthority(authLOCAL.authority);
            }
            navToLogin();
            //setLogPageReady(true);
        } else {
            import.meta.env.DEV === true && console.log("‹no_acc_02›");

            let passRes = params.get("passreset");
            if (passRes !== null) {
                localStorage.removeItem(localStorageFactoryTokKey);
                sessionStorage.removeItem(localStorageFactoryTokKey);
                updateAuthority(authLOCAL.authority);
            }
            navToLogin();
            //setLogPageReady(true);
        }
    }, [msalInstance]);

    const changeStory = (storyId: landStoryIds) => {
        setActiveStory(prev => ({
                ...prev,
                storyid: storyId
            })
        );
        setTimeout(() => {
            window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
        }, 300);
    }

    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}/>
            {msalReady === true ? (
                <Outlet />
            ) : logPageReady == true ? (
                <div className={styles.area}>
                    {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                        <div className={styles.accordionTopRight}>
                            <MainAccordion activeStoryId={activeStory.storyid} changeStory={changeStory} />
                            <NavLogBut displayText="More" target="/details" />
                        </div>
                    )}
                    <div className={styles.loginContainer} id="kgnfLoginCont">
                        <img src={kognifyLogo} height="100px" className={styles.kognifyBanner}/>

                        {getRedeemToken() !== null ? (
                            <div>
                                <div className={styles.redeemGreeting}>
                                    Hey, you were invited to a Kognify Space <br />
                                    <span style={{ fontSize: "25px", lineHeight: "2" }}>
                                        <b>{getRedeemSpaceName()}</b>
                                    </span>
                                    <br /> Please signup in your preferred way
                                </div>
                            </div>
                        ) : null}
                        <TooltipHost
                            content="Sign Up/Sign In with an Email Address"
                            directionalHint={import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" ? DirectionalHint.topCenter : DirectionalHint.bottomCenter}
                        >
                            <LoginButton
                                imgSrc={loginLoc}
                                text="SIGN IN WITH MAIL"
                                authorityURI={authLOCAL.authority}
                                onAction={onAction}
                                isIFrame={isIFrame}
                            />
                        </TooltipHost>
                        {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                            <div>
                                <TooltipHost content="Sign In with your Work or Personal Microsoft Account" directionalHint={DirectionalHint.rightCenter}>
                                    <LoginButton
                                        imgSrc={LoginMS}
                                        text="SIGN IN WITH MICROSOFT"
                                        authorityURI={authMS.authority}
                                        onAction={onAction}
                                        isIFrame={isIFrame}
                                    />
                                </TooltipHost>
                                <TooltipHost content="Sign In with your Personal or Worplace Google Account" directionalHint={DirectionalHint.bottomCenter}>
                                    <LoginButton
                                        imgSrc={loginGoo}
                                        text="SIGN IN WITH GOOGLE"
                                        authorityURI={authGOOGLE.authority}
                                        onAction={onAction}
                                        isIFrame={isIFrame}
                                    />
                                </TooltipHost>
                            </div>
                        )}
                        {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                        <div className={styles.contactIcons}>
                            <div className={styles.lincontainerinfo} onClick={() => window.open("https://www.linkedin.com/company/kgnf", "_blank")}>
                                <TooltipHost content="Keep up with us in LinkedIn" directionalHint={DirectionalHint.bottomCenter}>
                                    <img src={linkedinLogo} className={styles.linlogo}></img>
                                </TooltipHost>
                            </div>
                            <a href="mailto:hey@kgnfy.com" className={styles.mailcontainer}>
                                <TooltipHost content="Contact us via mail" directionalHint={DirectionalHint.bottomCenter}>
                                    <IoMail size={21} color="#ffff"/>
                                </TooltipHost>
                            </a>
                        </div>
                        )}
                    </div>
                    {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                        activeSlide  == 0 && (<div className={styles.sectionSubSubSub}>Check out one of our flagship products!</div>)
                    )}
                    {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                        activeSlide  == 0 && <ScrollDownAnimatedArrows contClassName={"mainArrows"} clickAreaClassName={"mainArrowsClickArea"} />
                    )}
                    {/* decorative background circles */}
                    <ul className={styles.circles}>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                        activeStory.storyid === "acc" ? <AutonomousCallCenter /> : <AutonomousAP />
                    )}
                </div>
            ) : (
                <div className={styles.area}>
                    {/* decorative background circles */}
                    <ul className={styles.circles}>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                    {import.meta.env.VITE_LOCAL_ONLY_LOGIN_MODE != "True" && (
                        activeStory.storyid === "acc" ? <AutonomousCallCenter /> : <AutonomousAP />
                    )}
                </div>
            )}

        </div>
    );
};

export default Layout;
